import { COMMERCIAL_SITE } from '@connexio/shared/constants';

/** In-app / public enquiry form when no sales mailbox is configured yet. */
export const ENTERPRISE_CONTACT_PATH = '/contact';

/** Mailto when a sales address exists; otherwise the enquiry form. Never `/`. */
export function commercialContactHref(): string {
  return COMMERCIAL_SITE.contactEmail
    ? `mailto:${COMMERCIAL_SITE.contactEmail}`
    : ENTERPRISE_CONTACT_PATH;
}

/** Same-origin path for a commercial URL, or null when the link should leave the app. */
export function commercialOnSitePath(url: string): string | null {
  const origin = COMMERCIAL_SITE.canonicalOrigin;
  if (url.startsWith(origin)) {
    const path = url.slice(origin.length);
    return path.length === 0 ? '/' : path;
  }
  if (url.startsWith('/')) return url;
  return null;
}
